module.exports = __webpack_public_path__ + "media/images/icon_list/dots-71990d788d9b63ed2f90315ea97e298b.svg";